// Shared cell-render helpers for the Widget Studio generated screens.
//
// CHG-2471 / ITER-905213 — Widget Studio S5. `chip` / single-value badge cells
// are not built-in DataTable/StatCard types, so the generator emits custom
// columns / custom_render cards bound to render helpers. These shared builders
// keep the per-screen helpers thin (and DRY across the catalog + observation
// screens). Design-system tokens only — no hardcoded color (composition-lint).

import { createElement } from "react";
import type { ReactNode } from "react";

export interface Tone {
  bg: string;
  fg: string;
}

const NEUTRAL: Tone = { bg: "var(--color-bg-subtle)", fg: "var(--color-text-secondary)" };

// A small neutral chip for a single string value (e.g. family, page_type).
export function chipCell(value: string | null | undefined): ReactNode {
  const text = (value ?? "").toString().trim();
  if (!text) {
    return createElement("span", { style: { color: "var(--color-text-subtle)" } }, "—");
  }
  return createElement(
    "span",
    {
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 20,
        padding: "0 8px",
        fontSize: 11,
        fontWeight: 500,
        background: NEUTRAL.bg,
        color: NEUTRAL.fg,
        border: "1px solid var(--color-border-subtle)",
        borderRadius: 9999,
        textTransform: "capitalize",
      },
    },
    text.replace(/_/g, " "),
  );
}

// A toned status badge driven by a value→Tone map (falls back to neutral).
export function toneBadge(
  value: string | null | undefined,
  toneMap: Record<string, Tone>,
): ReactNode {
  const status = (value ?? "").toString();
  const tone = toneMap[status] ?? NEUTRAL;
  return createElement(
    "span",
    {
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 22,
        padding: "0 10px",
        fontSize: 12,
        fontWeight: 600,
        background: tone.bg,
        color: tone.fg,
        borderRadius: 9999,
        textTransform: "capitalize",
      },
    },
    status ? status.replace(/_/g, " ") : "—",
  );
}
